import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import QuestionBox from '../../Components/QuestionBox/QuestionBox'
import UserPanelTitle from '../../Components/UserPanelTitle/UserPanelTitle'
import './Counseling.css'
import counseling from '../../Assets/images/counseling/7566.jpg'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration'
import Swal from "sweetalert2";
import { Helmet } from 'react-helmet-async'

export default function Counseling() {
    const [faq, setFaq] = useState([]);
    useEffect(() => {
        axiosConfig.get("api/Faq").then((result) => {
            setFaq(result.data)
        }).catch((err) => {

        });
    }, [])

    function sendCounselingData() {
        axiosConfig.post("api/counseling", {
            fullName: document.getElementById("counselingFullName").value,
            phoneNumber: document.getElementById("counselingPhoneNumber").value,
            description: document.getElementById("description").value,
        }).then((res) => {
            Swal.fire({
                title: res.data.message,
                icon: "success",
                confirmButtonText: "تایید",
            });
        }).catch((res) => {
        });
    }
    return (
        <>
            <Helmet>
                <title>تماس با ما | پشتیبانی 24 ساعته سه‌نیک</title>
                <meta
                    name="description"
                    content="راه‌های مختلف ارتباط با تیم پشتیبانی سه‌نیک برای پاسخگویی سریع به سوالات و راهنمایی‌های تخصصی. همراه شما در مسیر یادگیری و توسعه."
                />
            </Helmet>
            <div className='counseling'>
                <Container>
                    <div className='faq-section'>
                        <div className='faq-section-title'>
                            <UserPanelTitle title='سوالات متداول' />
                        </div>

                        <div className='questions'>
                            {
                                faq.map((item) => (
                                    <QuestionBox question={item.question} answer={item.answer} />
                                ))
                            }
                        </div>
                    </div>
                    <div className='counseling-message'>
                        <div className='counseling-message-title'>
                            <UserPanelTitle title='درخواست مشاوره' />
                        </div>
                        <div className='counseling-message-content'>
                            <Row className='counseling-message-content-row'>
                                <Col lg={6}>
                                    <div className='counseling-message-box'>
                                        <input type="text" id='counselingFullName' placeholder='نام و نام خانوادگی' />
                                        <input type="text" id='counselingPhoneNumber' placeholder='شماره موبایل' />
                                        <input type="text" id='description' placeholder='توضیحات' />
                                        <button onClick={sendCounselingData}>درخواست نوبت مشاوره</button>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className='counseling-message-image'>
                                        <img src={counseling} alt="درخواست مشاوره سه نیک" />
                                    </div>
                                </Col>
                            </Row>

                        </div>

                    </div>
                </Container>
            </div>
        </>

    )
}
